import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownEditorProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

export const MarkdownEditor: React.FC<MarkdownEditorProps> = ({ value, onChange, disabled }) => {
  return (
    <div style={{ width: '100%' }}>
      <MDEditor
        value={value}
        onChange={v => onChange(v || '')}
        preview="live"
        height={260}
        visiableDragbar={false}
        textareaProps={{
          placeholder: '请输入Markdown格式的消息内容...',
          disabled,
        }}
      />
    </div>
  );
};
